/**
 * Contains all the data points related Premium Dashboard
 */
export default {
    PremiumDashManageSubscription: {
        datapoint: {
            name: 'PremiumDashManageSubscriptionClicked',
        },
    },
};
//# sourceMappingURL=datapoints.js.map